'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/ArrowSquareOut.es.js";
const o = a.forwardRef((e$1, t) => /* @__PURE__ */ a.createElement(p, { ref: t, ...e$1, weights: e }));
o.displayName = "ArrowSquareOutIcon";
const n = o;
export {
  n as ArrowSquareOut,
  o as ArrowSquareOutIcon
};
